import { render, staticRenderFns } from "./Guide.vue?vue&type=template&id=586b315a&scoped=true"
import script from "./Guide.vue?vue&type=script&lang=js"
export * from "./Guide.vue?vue&type=script&lang=js"
import style0 from "./Guide.vue?vue&type=style&index=0&id=586b315a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586b315a",
  null
  
)

export default component.exports